var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderEllipse(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 387,
    height: 105,
    viewBox: "0 0 387 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385 52.4998C385 58.6844 380.354 65.068 370.714 71.2518C361.166 77.3766 347.217 82.9676 329.801 87.6927C295 97.1351 246.809 103 193.5 103C140.191 103 92.0004 97.1351 57.1985 87.6927C39.7832 82.9676 25.8342 77.3766 16.286 71.2518C6.64599 65.068 2 58.6844 2 52.4998C2 46.3152 6.64599 39.9317 16.286 33.7479C25.8342 27.623 39.7832 22.032 57.1985 17.3069C92.0004 7.86457 140.191 1.99982 193.5 1.99982C246.809 1.99982 295 7.86457 329.801 17.3069C347.217 22.032 361.166 27.623 370.714 33.7479C380.354 39.9317 385 46.3152 385 52.4998Z",
    stroke: "url(#paint0_radial)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9355 -85.0501) rotate(54.5772) scale(246.831 1150.55)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderEllipse);
export default __webpack_public_path__ + "static/media/orderEllipse.90b0bbc0ee2092a2a74c08cba3c69a12.svg";
export { ForwardRef as ReactComponent };